export default {
    innerTop: "#215803",
    innerBottom: "#215803",
    slightTop: "#97dbed",
    slightBottom: "#e38293",
    mediumTop: "#00a3e9",
    mediumBottom: "#ef1821",
    severeTop: "#2834a6",
    severeBottom: "#840012",
} 